// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-icon {
  font-size: 1.3rem;
  color: var(--ion-color-secondary-contrast);
}

.inputfile {
  opacity: 0;
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  left: 0;
  z-index: 999;
  cursor: pointer;
}

ion-content {
  max-height: calc(100% - 56px) !important;
  height: 744px !important;
}

.embed-config-item {
  border: 1px solid var(--ion-color-medium);
  border-radius: 12px;
  margin-bottom: 16px;
  overflow: hidden;
  background: var(--ion-color-step-50, rgba(0, 0, 0, 0.02));
}
.embed-config-item .embed-config-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 12px 8px 14px;
  background: var(--ion-color-tertiary);
  border-radius: 12px 12px 0 0;
}
.embed-config-item .embed-config-header .embed-config-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 0.78rem;
  font-weight: 700;
  color: var(--ion-color-tertiary-contrast);
  letter-spacing: 0.6px;
}
.embed-config-item .embed-config-header .embed-config-badge ion-icon {
  font-size: 1rem;
  color: var(--ion-color-tertiary-contrast);
}
.embed-config-item .embed-config-fields {
  padding: 4px 0;
}
.embed-config-item .embed-config-fields .field-icon {
  font-size: 1rem;
  color: var(--ion-color-medium);
  margin-top: 18px;
}
.embed-config-item .embed-option-section {
  padding: 10px 14px 14px;
  border-top: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
  margin-top: 4px;
}
.embed-config-item .embed-option-section .embed-option-label {
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.5px;
  opacity: 0.55;
  margin: 0 0 4px 0;
}
.embed-config-item .embed-option-section .embed-radio-group {
  display: flex;
  flex-direction: row;
  gap: 8px;
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option {
  flex: 1;
  border-color: var(--ion-color-secondary);
  border-radius: 8px;
  overflow: hidden;
  transition: border-color 0.15s, background 0.15s;
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option ion-item {
  --padding-start: 10px;
  --inner-padding-end: 10px;
  --min-height: 44px;
  --background: transparent;
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option ion-radio {
  color: var(--ion-color-secondary) !important;
  --color-checked: var(--ion-color-medium);
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option .radio-icon {
  font-size: 1.1rem;
  color: var(--ion-color-medium);
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option.embed-radio-selected {
  border: 2px solid var(--ion-color-medium);
  background: rgba(var(--ion-color-medium-rgb), 0.1);
}
.embed-config-item .embed-option-section .embed-radio-group .radio-option.embed-radio-selected .radio-icon {
  color: var(--ion-color-medium);
}
.embed-config-item .embed-image-section {
  padding: 10px 14px 14px;
  border-top: 1px solid var(--ion-color-step-150, rgba(0, 0, 0, 0.08));
}
.embed-config-item .embed-image-section .embed-image-preview {
  border-radius: 8px;
  overflow: hidden;
  margin-bottom: 10px;
  max-height: 140px;
}
.embed-config-item .embed-image-section .embed-image-preview ion-img::part(image) {
  max-height: 140px;
}
.embed-config-item .embed-image-section .embed-upload-btn {
  position: relative;
  --background: var(--ion-color-adminDetailsViewActive, var(--ion-color-medium));
  max-width: 60%;
  margin-left: 20%;
}
.embed-config-item .embed-image-section .embed-upload-btn .inputfile {
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 999;
  cursor: pointer;
}

.embed-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px 0 8px;
  opacity: 0.45;
}
.embed-empty-state .embed-empty-icon {
  font-size: 2rem;
  margin-bottom: 6px;
}
.embed-empty-state p {
  font-size: 0.85rem;
  margin: 0;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/modals/collapsable-title-modal/collapsable-title-modal.component.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,0CAAA;AACF;;AAEA;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,YAAA;EACA,OAAA;EACA,YAAA;EACA,eAAA;AACF;;AAEA;EACE,wCAAA;EACA,wBAAA;AACF;;AAGA;EACE,yCAAA;EACA,mBAAA;EACA,mBAAA;EACA,gBAAA;EACA,yDAAA;AAAF;AAEE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,0BAAA;EACA,qCAAA;EACA,4BAAA;AAAJ;AAEI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gBAAA;EACA,yCAAA;EACA,qBAAA;AAAN;AAEM;EACE,eAAA;EACA,yCAAA;AAAR;AAKE;EACE,cAAA;AAHJ;AAKI;EACE,eAAA;EACA,8BAAA;EACA,gBAAA;AAHN;AAOE;EACE,uBAAA;EACA,oEAAA;EACA,eAAA;AALJ;AAOI;EACE,kBAAA;EACA,gBAAA;EACA,qBAAA;EACA,aAAA;EACA,iBAAA;AALN;AAQI;EACE,aAAA;EACA,mBAAA;EACA,QAAA;AANN;AAQM;EACE,OAAA;EACA,wCAAA;EAEA,kBAAA;EACA,gBAAA;EACA,gDAAA;AAPR;AASQ;EACE,qBAAA;EACA,yBAAA;EACA,kBAAA;EACA,yBAAA;AAPV;AAUQ;EACE,4CAAA;EAEA,wCAAA;AATV;AAYQ;EACE,iBAAA;EACA,8BAAA;AAVV;AAaQ;EACG,yCAAA;EACD,kDAAA;AAXV;AAaU;EACG,8BAAA;AAXb;AAkBE;EACE,uBAAA;EACA,oEAAA;AAhBJ;AAkBI;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,iBAAA;AAhBN;AAkBM;EACE,iBAAA;AAhBR;AAoBI;EACE,kBAAA;EACA,8EAAA;EACA,cAAA;EACA,gBAAA;AAlBN;AAoBM;EACE,UAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAlBR;;AAyBA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,mBAAA;EACA,aAAA;AAtBF;AAwBE;EACE,eAAA;EACA,kBAAA;AAtBJ;AAyBE;EACE,kBAAA;EACA,SAAA;AAvBJ","sourcesContent":[".section-icon {\n  font-size: 1.3rem;\n  color: var(--ion-color-secondary-contrast);\n}\n\n.inputfile {\n  opacity: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  z-index: 999;\n  cursor: pointer;\n}\n\nion-content {\n  max-height: calc(100% - 56px) !important;\n  height: 744px !important;\n}\n\n// Embed config card items\n.embed-config-item {\n  border: 1px solid var(--ion-color-medium);\n  border-radius: 12px;\n  margin-bottom: 16px;\n  overflow: hidden;\n  background: var(--ion-color-step-50, rgba(0,0,0,0.02));\n\n  .embed-config-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 8px 12px 8px 14px;\n    background: var(--ion-color-tertiary);\n    border-radius: 12px 12px 0 0;\n\n    .embed-config-badge {\n      display: flex;\n      align-items: center;\n      gap: 6px;\n      font-size: 0.78rem;\n      font-weight: 700;\n      color: var(--ion-color-tertiary-contrast);\n      letter-spacing: 0.6px;\n\n      ion-icon {\n        font-size: 1rem;\n        color: var(--ion-color-tertiary-contrast);\n      }\n    }\n  }\n\n  .embed-config-fields {\n    padding: 4px 0;\n\n    .field-icon {\n      font-size: 1rem;\n      color: var(--ion-color-medium);\n      margin-top: 18px;\n    }\n  }\n\n  .embed-option-section {\n    padding: 10px 14px 14px;\n    border-top: 1px solid var(--ion-color-step-150, rgba(0,0,0,0.08));\n    margin-top: 4px;\n\n    .embed-option-label {\n      font-size: 0.75rem;\n      font-weight: 600;\n      letter-spacing: 0.5px;\n      opacity: 0.55;\n      margin: 0 0 4px 0;\n    }\n\n    .embed-radio-group {\n      display: flex;\n      flex-direction: row;\n      gap: 8px;\n\n      .radio-option {\n        flex: 1;\n        border-color: var(--ion-color-secondary);\n\n        border-radius: 8px;\n        overflow: hidden;\n        transition: border-color 0.15s, background 0.15s;\n\n        ion-item {\n          --padding-start: 10px;\n          --inner-padding-end: 10px;\n          --min-height: 44px;\n          --background: transparent;\n        }\n\n        ion-radio {\n          color: var(--ion-color-secondary) !important;\n\n          --color-checked: var(--ion-color-medium);\n        }\n\n        .radio-icon {\n          font-size: 1.1rem;\n          color: var(--ion-color-medium);\n        }\n\n        &.embed-radio-selected {\n           border: 2px solid var(--ion-color-medium);\n          background: rgba(var(--ion-color-medium-rgb), 0.1);\n\n          .radio-icon {\n             color: var(--ion-color-medium);\n          }\n        }\n      }\n    }\n  }\n\n  .embed-image-section {\n    padding: 10px 14px 14px;\n    border-top: 1px solid var(--ion-color-step-150, rgba(0,0,0,0.08));\n\n    .embed-image-preview {\n      border-radius: 8px;\n      overflow: hidden;\n      margin-bottom: 10px;\n      max-height: 140px;\n\n      ion-img::part(image) {\n        max-height: 140px;\n      }\n    }\n\n    .embed-upload-btn {\n      position: relative;\n      --background: var(--ion-color-adminDetailsViewActive, var(--ion-color-medium));\n      max-width: 60%;\n      margin-left: 20%;\n\n      .inputfile {\n        opacity: 0;\n        position: absolute;\n        top: 0;\n        left: 0;\n        width: 100%;\n        height: 100%;\n        z-index: 999;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n// Empty state\n.embed-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  padding: 24px 0 8px;\n  opacity: 0.45;\n\n  .embed-empty-icon {\n    font-size: 2rem;\n    margin-bottom: 6px;\n  }\n\n  p {\n    font-size: 0.85rem;\n    margin: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
